export class CheckboxModel {
    value: string;
    checked: boolean;

    constructor(init?: Partial<CheckboxModel>) {
        Object.assign(this, init);
    }
}
